import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { Grid, Input, Button } from '@ali/aps-dev';
import './bannerTop.scss';

const Row = Grid.Row;
const Col = Grid.Col;

class SearchBox extends Component {
  render() {
    return (
      <div className="search">
        <Grid>
          <Row>
            <Col>
              <div className="search-box">
                <Input
                  className="search-input"
                  size='large'
                  placeholder='请输入域名关键词查询，如：baijinci'
                  value={this.props.value}
                  onChange={this.props.handlerInputChange}
                  onKeyUp={this.props.handlerEnterFind} />
                <Button
                  className="btn find-btn"
                  type="normal"
                  onClick={this.props.handlerSearchResult}>搜索</Button>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default SearchBox;


// WEBPACK FOOTER //
// ./src/components/BannerTop/SearchBox.js